module.exports = {
  "country": "IT",
  "artist": "Il Volo",
  "song": "Grande Amore",
  "year": "2015",
  "place": "3",
  "spotify": "4hWQaCHO3k3bTYi8AozKTE"
};